import React, { useEffect, useState } from 'react'
import OuterHeader from '../../jsx/layouts/outerHeader'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import acceptCompanyInvitationApi from '../../service/api/companies/acceptCompanyInvitation';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { userDetailsByToken } from '../../service/api/user/userTokenDetails';

const CompanyInvitation = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [invitationLoading, setInvitationLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [toggleForSuccess, setToggleForSuccess] = useState(false);
    const [signUpFlag, setSignUpFlag] = useState(false);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let pageType = "";

    let companyInvitationToken = "";

    if (urlParams.has('companyInvitationToken')) {
        companyInvitationToken = urlParams.get('companyInvitationToken')
    }


    useEffect(() => {
        if (companyInvitationToken) {
            setInvitationLoading(true);
            let data = {
                token_id: companyInvitationToken
            }
            dispatch(userDetailsByToken(data, (res) => {
                setInvitationLoading(false);
                console.log(res?.data?.message, "res res?.data?.message");
                setSuccessMsg(res?.data?.message);

                res?.data?.data?.email_chr && localStorage.setItem("emailCompanyInvite", res?.data?.data?.email_chr);
                res?.data?.data?.phone_code_id_int && localStorage.setItem("phoneCodeCompanyInvite", res?.data?.data?.phone_code_id_int);
                res?.data?.data?.phone_number_int && localStorage.setItem("phoneNumberCompanyInvite", res?.data?.data?.phone_number_int);
                res?.data?.data?.role_id_int && localStorage.setItem("roleCompanyInvite", res?.data?.data?.role_id_int);
                res?.data?.data?.company_id_ids && localStorage.setItem("companyIdInvite", res?.data?.data?.company_id_ids);
                res?.data?.data?.invitation_id && localStorage.setItem("companyInvitationIdInvite", res?.data?.data?.invitation_id);

                if (res?.data?.sign_up_flag) {
                    navigate('/signUpPro')
                } else if (!res?.data?.sign_up_flag) {
                    navigate('/login')
                }

            }, (err) => {
                setInvitationLoading(false);
                console.log(err, "err userDetailsByToken");

                setResponceMsg(err?.data?.message);
                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 2000);

                const id = setTimeout(() => {
                    navigate('/login')
                }, 2000);

                return () => {
                    clearTimeout(id);
                }

            }))
        }
    }, [])

    const handleCompanyInvitation = () => {
        if (companyInvitationToken) {

            let data = new FormData();
            data.append('company_invitation_token', companyInvitationToken);

            setInvitationLoading(true);

            // dispatch(updateBackDropLoaderWithoutStateTrue());

            dispatch(acceptCompanyInvitationApi(data, (res) => {

                console.log(res, "res acceptCompanyInvitationApi");
                setSuccessMsg(res?.data?.message);

                setInvitationLoading(false);

                res?.data?.data?.email_chr && localStorage.setItem("emailCompanyInvite", res?.data?.data?.email_chr);
                res?.data?.data?.phone_code_id_int && localStorage.setItem("phoneCodeCompanyInvite", res?.data?.data?.phone_code_id_int);
                res?.data?.data?.phone_number_int && localStorage.setItem("phoneNumberCompanyInvite", res?.data?.data?.phone_number_int);
                res?.data?.data?.role_id_int && localStorage.setItem("roleCompanyInvite", res?.data?.data?.role_id_int);
                res?.data?.data?.company_id_ids && localStorage.setItem("companyIdInvite", res?.data?.data?.company_id_ids);
                res?.data?.data?.invitation_id && localStorage.setItem("companyInvitationIdInvite", res?.data?.data?.invitation_id);

                setToggleForSuccess(true);

                if (res?.data?.sign_up_flag) {
                    setSignUpFlag(true);
                } else if (!res?.data?.sign_up_flag) {
                    setSignUpFlag(false);
                }

                // if (res?.data?.sign_up_flag) {
                //     const id = setTimeout(() => {
                //         navigate('/signup')
                //     }, 4000);

                //     return () => {
                //         clearTimeout(id);
                //     }
                // } else if (!res?.data?.sign_up_flag) {
                //     const id = setTimeout(() => {
                //         navigate('/login')
                //     }, 4000);

                //     return () => {
                //         clearTimeout(id);
                //     }
                // }

            }, (err) => {
                console.log(err, "err acceptCompanyInvitationApi");
                // setCustomLoading(false);

                setInvitationLoading(false);

                setResponceMsg(err?.data?.message);
                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 4000);

                const id = setTimeout(() => {
                    navigate('/login')
                }, 3000);

                return () => {
                    clearTimeout(id);
                }
            }))
        } else {
            setResponceMsg("Something went wrong. Please try later.");
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 4000);

            const id = setTimeout(() => {
                navigate('/login')
            }, 3000);

            return () => {
                clearTimeout(id);
            }
        }
    }



    const handleConfirmation = () => {
        if (signUpFlag) {
            navigate('/signup')
        } else {
            navigate('/login')
        }
    }

    // useEffect(() => {
    //     if (!companyInvitationToken) {
    //         navigate('/login')
    //     }
    // }, [companyInvitationToken])


    return (
        <>
            <div className='row mx-0'>
                <div className='col-12 px-0'>
                    <OuterHeader />

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '80dvh' }}
                            >

                                {invitationLoading ?
                                    <div className='d-flex flex-column align-items-center'>
                                        <Spinner animation="border" size='lg' variant="primary" />
                                        <div className='mt-3'>
                                            <span>{`Please wait`}</span>
                                        </div>
                                    </div> :
                                    <div className='d-flex flex-column align-items-center'>
                                        <div className='fs-4 font-w600 text-black'>
                                            <span>{`${successMsg}`}</span>
                                        </div>
                                    </div>
                                }

                                {/* <div
                                    className='d-flex justify-content-center align-items-center flex-column p-3'
                                    style={{ maxWidth: "600px" }}
                                >
                                    {!toggleForSuccess ?
                                        <>
                                            <div className='fs-2 font-w600 text-black text-center mb-5'>
                                                <span>{`If you want to join the company please accept invitation`}</span>
                                            </div>

                                            <div className='fs-5 font-w500 d-flex mt-3'>
                                                <div className='d-flex me-2' style={{ color: '#4e5d74', width: '115px' }}>
                                                    <span>
                                                        <i className="fa fa-info-circle me-2" ></i>
                                                    </span>
                                                    <span className='font-w600'>{`Note:`}</span>
                                                </div>
                                                <div>
                                                    <span>{`Your current subscription will be cancelled after joining the company, if you already have a Chilll account`}</span>
                                                </div>
                                            </div>

                                            <div className='row mt-5 w-100 '>

                                                <div className='col-6 pe-2 mt-2'>
                                                    <PrimaryButton
                                                        buttonName={`CANCEL`}
                                                        onClick={(e) => { navigate('/login') }}
                                                        loadingMessage={"Saving..."}
                                                        isLoading={false}
                                                        style={{
                                                            width: '100%',
                                                            background: '#4e5d74',
                                                            border: 'none',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>

                                                <div className='col-6 ps-2 mt-2'>
                                                    <PrimaryButton
                                                        buttonName={`ACCEPT`}
                                                        onClick={(e) => { handleCompanyInvitation() }}
                                                        loadingMessage={"ACCEPTING..."}
                                                        isLoading={invitationLoading}
                                                        style={{
                                                            width: '100%',
                                                            border: 'none',
                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </> :
                                        <>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                <div
                                                    className='rounded-circle d-flex justify-content-center align-items-center'
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        border: '3px solid #19DF5C',
                                                    }}
                                                >
                                                    <i className='fa fa-check' style={{ fontSize: '25px', color: "#19DF5C" }}></i>
                                                </div>
                                            </div>

                                            <div className='fs-2 font-w600 text-black text-center mb-5 mt-3'>
                                                <span>{`${successMsg ? successMsg : "Please signup to the create account!"}`}</span>
                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <PrimaryButton
                                                        buttonName={`OK`}
                                                        onClick={(e) => { handleConfirmation() }}
                                                        loadingMessage={"Saving..."}
                                                        isLoading={false}
                                                        style={{
                                                            width: '100px',
                                                            background: '#4e5d74',
                                                            border: 'none',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

        </>
    )
}

export default CompanyInvitation